import { useEffect } from 'react';
import isObject from 'lodash/isObject';
import { useFormikContext } from 'formik';

const getFirstErrorKey = (object, keys = []) => {
  const firstErrorKey = Object.keys(object)[0];
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
  }
  return [...keys, firstErrorKey].join('.');
};

const FormikOnError = ({ children, withFocus }) => {
  const formik = useFormikContext();

  useEffect(() => {
    if (!formik.isValid && formik.submitCount > 0) {
      const firstErrorKey = getFirstErrorKey(formik.errors);
      const errorsElements = window?.document.getElementsByName(firstErrorKey);
      const elScrollTo = errorsElements[0];
      if (errorsElements.length && elScrollTo) {
        if (withFocus) {
          // focus element or element of select field that use hidden inputs
          if (elScrollTo.getAttribute('type') === 'hidden') {
            const focusedElement = document.querySelector(`[id*="${firstErrorKey}"]`);
            if (focusedElement) focusedElement.focus({ preventScroll: false });
          } else {
            elScrollTo.focus();
          }
        } else {
          elScrollTo.parentNode.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.submitCount, formik.isValid, formik.errors]);
  return children;
};

FormikOnError.defaultProps = {
  withFocus: false,
};

export default FormikOnError;
